import brand from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import { imageCoverContainer } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import { h1, paragraph } from '@helpers/typography';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import { m } from 'framer-motion';
import styled from 'styled-components';
import ArticleSummaryStyles from '../ArticleSummary/ArticleSummary.styles';
const Container = styled(m.article) `
  display: grid;
  grid-area: 1 / 1;
  height: 100%;
`;
const MediaWrapper = styled(m.div) `
  position: relative;
  display: block;
  grid-area: 1 / 1;
  overflow: hidden;
  overflow: clip;
  user-select: none;
  z-index: 1;

  section[data-header-overlap="true"] & {
    padding-top: var(--headerHeight);
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba(0, 0, 0, var(--tintAmount));
    width: 100%;
  }
`;
const Image = styled(m(SimpleImage)) `
  ${imageCoverContainer()}

  &[data-mobile-only=true] {
    @media ${from(Device.Tablet)} {
      display: none;
    }
  }
`;
const Video = styled.video `
  ${imageCoverContainer()}

  &[data-hide-mobile=true] {
    @media ${until(Device.Tablet)} {
      display: none;
    }
  }
`;
const Inner = styled.div `
  ${siteWide};

  position: relative;
  display: grid;
  align-items: center;
  grid-area: 1 / 1;
  grid-template-rows: 1fr auto;
  padding-bottom: 61px;
  z-index: 2;

  section[data-header-overlap="true"] & {
    padding-top: var(--headerHeight);
  }
    
  @media ${from(Device.Tablet)} {
    padding-bottom: 77px;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-template-columns: auto 1fr;
    padding-left: 118px;
    padding-bottom: 0;
  }
`;
const ContentWrapper = styled(m.div) ``;
const Title = styled(m.h2) `
  ${h1};
  margin-bottom: 12px;

  @media ${from(Device.Tablet)} {
    margin-bottom: 24px;
  }

  @media ${from(Device.DesktopSmall)} {
    max-width: 670px;
  }
`;
const Content = styled(m.p) `
  ${paragraph};
  margin-bottom: 0;
  max-width: 485px;
`;
const CtaWrapper = styled(m.div) `
  display: block;
  margin-top: 24px;

  @media ${from(Device.Tablet)} {
    margin-top: 46px;
  }
`;
const ArticleList = styled(m.div) `
  display: flex;
  flex-direction: column;

  @media ${until(Device.DesktopSmall)} {
    ${ArticleSummaryStyles.Container}:first-child {
      border-top: 1px solid ${brand.grey.otherGrey};
      border-bottom: 1px solid ${brand.grey.otherGrey};
      margin-bottom: 0;
      padding-top: 24px;
      padding-bottom: 24px;
    }

    ${ArticleSummaryStyles.Container}:not(:first-child) {
      display: none;
    }
  }

  @media ${from(Device.DesktopSmall)} {
    justify-self: flex-end;
    max-width: 417px;
    width: 100%;
  }
`;
const BannerItemStyles = {
    ArticleList,
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    Image,
    MediaWrapper,
    Inner,
    Title,
    Video,
};
export default BannerItemStyles;
